import { render, staticRenderFns } from "./NewVisitor.vue?vue&type=template&id=21b34f84&scoped=true&"
import script from "./NewVisitor.vue?vue&type=script&lang=js&"
export * from "./NewVisitor.vue?vue&type=script&lang=js&"
import style0 from "./NewVisitor.vue?vue&type=style&index=0&id=21b34f84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b34f84",
  null
  
)

export default component.exports